export const SessionBookerIframe = ({ ...props }) => (
  <iframe
    title="Book Live Session Now"
    src="https://calendly.com/hoa-personal-training/30min-personal-training?hide_gdpr_banner=1&background_color=1a1a1a&text_color=ffffff&primary_color=a78256&&embed_type=Inline&embed_domain=1"
    {...props}
  />
);
